// extracted by mini-css-extract-plugin
export var messageSideLeft = "_oj-1";
export var stateContainer = "_oj-0";